import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import { rsAddress, rsProgress, rsOrderPrint } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import Barcode from "react-barcode";
import ReactToPrint from "react-to-print";
import { toMoney } from "../../util/Utils";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMotorDelivery } from "./UseMotorDelivery";
import { readFromLS } from "../../util/LocalStrogeService";

export default function OrderPrint(props) {
  const [msAddress, setMsAddress] = useRecoilState(rsAddress);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const componentRef = useRef();
  const [state, setState] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { GetDriversRoutes } = UseMotorDelivery();
  const [msOrderPrint, setMsOrderPrint] = useRecoilState(rsOrderPrint);

  useEffect(() => {
    setMsOrderPrint(true);
    if (localStorage.getItem("DriverModel")) {
      let LSVersion = readFromLS("DriverModel");
      GetDriversRoutes(LSVersion, (orders) => {
        setState(orders);
      });
    }
  }, [location.state]);

  return (
    state && (
      <>
        <ReactToPrint
          copyStyles={true}
          trigger={() => (
            <Button
              sx={{ m: 2, width: "100px" }}
              aria-label="Print Licensee profile"
              aria-haspopup="false"
              color="secondary"
              variant="contained"
            >
              چاپ
            </Button>
          )}
          content={() => componentRef.current}
        />
        {state && (
          <Box
            ref={componentRef}
            sx={{
              width: "28cm",
              ml: 5,
              direction: "ltr",
            }}
          >
            <Box sx={{ height: "1cm" }}></Box>
            <Box
              sx={{
                m: 2,
                // width: "100%",
                p: 1,
                fontSize: "18px",
                border: ".3px solid black",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "18px",
                }}
                fontWeight="bold"
                variant="body1"
              >
                {state.part}
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "18px",
                }}
                fontWeight="bold"
                variant="body1"
              >
                {state.shamsiDeliveryDate}
              </Typography>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "18px",
                }}
                fontWeight="bold"
                variant="body1"
              >
                راکب : {state.driver}
              </Typography>
            </Box>
            <Box
              sx={{
                border: ".3px solid black",
                m: 2,
                mt: 3,
              }}
            >
              <Box
                sx={{
                  borderBottom: ".3px solid black",
                  py: 1,
                }}
                display="grid"
                gridTemplateColumns="repeat(16, 1fr)"
                gap={1}
              >
                <Box gridColumn="span 1">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    ردیف
                  </Typography>
                </Box>

                <Box gridColumn="span 1">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    سفارش
                  </Typography>
                </Box>
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    نام
                  </Typography>
                </Box>
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    موبایل
                  </Typography>
                </Box>
                <Box gridColumn="span 2">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    محله
                  </Typography>
                </Box>
                <Box gridColumn="span 8">
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      fontSize: "18px",
                    }}
                  >
                    آدرس
                  </Typography>
                </Box>
              </Box>
              {state &&
                state.orders.map((model, i) => {
                  return (
                    <Box
                      key={i}
                      sx={{
                        borderBottom: ".3px solid black",
                        py: 2,
                      }}
                      display="grid"
                      gridTemplateColumns="repeat(16, 1fr)"
                      gap={1}
                    >
                      <Box gridColumn="span 1">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        >
                          {model.id}
                        </Typography>
                      </Box>

                      <Box gridColumn="span 1">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        >
                          {model.orderID}
                        </Typography>
                      </Box>
                      <Box gridColumn="span 2">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        >
                          {model.customer}
                        </Typography>
                      </Box>
                      <Box gridColumn="span 2">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        >
                          {model.mobile}
                          <br />
                          {model.phone}
                        </Typography>
                      </Box>
                      <Box gridColumn="span 2">
                        <Typography
                          variant="body2"
                          sx={{
                            textAlign: "center",
                            fontSize: "18px",
                          }}
                        >
                          {model.neighbourhood}
                        </Typography>
                      </Box>
                      <Box gridColumn="span 8">
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: "bold",
                            textAlign: "left",
                            fontSize: "18px",
                          }}
                        >
                          {model.address}
                        </Typography>
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        )}
      </>
    )
  );
}
